
function Chevron({ size = 16, color = "#000" }) {
	return (
		<svg height={size} width={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
			<g fill={color} stroke={color} strokeMiterlimit="10" strokeWidth="1">
				<polyline
					fill="none"
					points="5.5,0.5 10.5,8 5.5,15.5 "
					stroke={color}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
}

export default Chevron;
